module.exports = __webpack_public_path__ + "static/media/smile.39f9f3d4.svg";